import { render, staticRenderFns } from "./ChartOfAccountsForm.vue?vue&type=template&id=20618bad"
import script from "./ChartOfAccountsForm.vue?vue&type=script&lang=js"
export * from "./ChartOfAccountsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports